import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { parse, stringify } from 'qs';
import { useLocation, useNavigate } from 'react-router-dom';
import { meState, tokenState } from './plugins/ridge';

export const useAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const token = tokenState.useValue();
  const authenticated = token !== null;

  const logout = () => {
    meState.reset();
    tokenState.reset();
    queryClient.clear();
    navigate('/main');
  };
  return { authenticated, logout };
};

export function useQueryString(queryObject: any = {}) {
  const { search } = useLocation();
  const parsed = parse(search, { ignoreQueryPrefix: true });
  const searchObject = {
    page: '1',
    limit: '10',
    sort: { id: 'DESC' },
    ...parsed,
    ...queryObject,
  };
  return stringify(searchObject, { addQueryPrefix: true, encode: false });
}

interface DebounceProps<T> {
  value: T;
  delay: number;
}

export function useDebounce<T>({ value, delay }: DebounceProps<T>): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
